<div class="auth-page-content overflow-hidden p-0">
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-xl-4 text-center">
                <div class="error-500 position-relative"><img src="assets/images/error500.png" alt=""
                        class="img-fluid error-500-img error-img">
                    <!-- <h1 class="title text-muted"> No data </h1> -->
                </div>
                <div class="mt-4">
                    <h4>{{noDataMsg | translate}}</h4>
                    <p class="text-muted w-75 mx-auto">
                        {{noDataSubMsg | translate}}
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>